import PropTypes from 'prop-types';
import React from 'react';

/**
 * Render the title of the tooltip.
 *
 * @param {Object} props Component properties.
 * @returns {ReactElement} Div containing title.
 * @private
 */
export default function TooltipTitle({ children, className }) {
  return <div className={ className }>
    { children }
  </div>;
}

/**
 * Property types definition.
 *
 * @enum {Object} propTypes
 * @private
 */
TooltipTitle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
